import set from 'lodash/set'
import { object, string, number, date, AnyObject, ValidationError } from 'yup'
import { stripPhoneNumber } from '@utils/strings'

export const validations = {
  object,
  string,
  number,
  date,
  time: () =>
    object().shape({
      hour: number().required('Please select an hour'),
      minute: number().required('Please select the minute'),
      meridiem: string().required('Please select AM or PM').oneOf(['AM', 'PM']),
    }),
  phone: () =>
    string().test('valid-phone', 'Not a valid phone number', (value?: string) => {
      const stripped = stripPhoneNumber(value)
      return stripped.length >= 6
    }),
}

export function createValidator<
  V extends AnyObject,
  S extends AnyObject = { [K in keyof V]?: any }
>(_schema: S) {
  const schema = validations.object(_schema)

  return async (values: V) => {
    let errors: { [k in keyof S]?: string } | undefined = undefined

    try {
      await schema.validate(values, { abortEarly: false })
    } catch (err) {
      if (err instanceof ValidationError) {
        errors = err.inner.reduce((formErrors, innerError) => {
          if (innerError.path) {
            set(formErrors, innerError.path, innerError.message)
          }
          return formErrors
        }, {} as { [k in keyof S]: string | undefined })
      } else {
        throw err
      }
    } finally {
      return errors
    }
  }
}
